import { CreateSalesInvoiceInput } from 'types/graphql';

import { navigate } from '@redwoodjs/router';
import { useMutation } from '@redwoodjs/web';

import { showErrorLong, showSuccessToast } from 'src/components/Toasts/toast';
import { LogError } from 'src/lib';

import { CREATE_SALES_INVOICE } from '../../graphql/mutations/createSalesInvoice.mutation';

export const useCreateSalesInvoice = () => {
    const [createSalesInvoice, { loading }] = useMutation(CREATE_SALES_INVOICE, {
        onCompleted: (data) => {
            const salesInvoiceNumber = data?.createSalesInvoice?.sageInvoiceNumber
                ? `${data.createSalesInvoice.sageInvoiceNumber} `
                : '';
            showSuccessToast(`Sales invoice ${salesInvoiceNumber}created successfully`);
            navigate('/finance/sales-invoices');
        },
        onError: (error) => {
            showErrorLong(error?.message);
            LogError(error);
        },
    });

    return {
        isLoading: loading,
        handleCreateSalesInvoice: async (newSalesInvoiceData: CreateSalesInvoiceInput) => {
            return await createSalesInvoice({
                variables: {
                    input: newSalesInvoiceData,
                },
            });
        },
    };
};
